import React from 'react';

import { message, Input, Button} from 'antd';

import {getLanguage} from "../util/Toolbox";

import './css/login.css';

import axios from '../util/Api'
import logoLogin from './assets/login/logoLogin.png';
  
class Login extends React.Component {

  state = {
    conseil_LIST : [],
    IdentifiantMagasin : '',
    MotDePasse : '',
    language : getLanguage()
  }


  async componentDidMount() {
    
  }


  redirectToHome = () => {
    
    window.location.href= '/';
  }


  onClickLogin = () => {

    if(this.state.IdentifiantMagasin == ''){
      message.warning("Entrer l'identifiant magasin");
      return;
    }

    if(this.state.MotDePasse == ''){
      message.warning("Entrer le mot de passe du magasin");
      return;
    }

    axios.post('/analyse/login', {login : this.state.IdentifiantMagasin, password :this.state.MotDePasse},
    ).then(({data}) => {
      console.log(data);

      if(data.success == 'success'){
        if(data.user == undefined || data.user == null){
          console.log('Erreur lors l\'identification, vérifier l\'identifiant et le mot de passe');
          message.error("Erreur lors l'identification, vérifier l'identifiant et le mot de passe");
          return;
        }else{
          localStorage.setItem('MachineIdUnique', data.user.GUID_Compte);
          window.location.href= '/';
          this.redirectToHome();
        }
      }else{
        message.error("Erreur lors l'identification, vérifier l'identifiant et le mot de passe");
        return;
      }
    }).catch(function (error) {
      console.log("Error****:", error.message);
      message.error("Erreur lors l'identification, vérifier l'identifiant et le mot de passe");
    });

  }


  render() {

      return (

        <div className='loginWrapper'>

          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>


        
            <div className="form-container">
              <h2>Espace de connexion</h2>
              <div className='imgLogin'>
                <img loading="lazy"  src={logoLogin} />
              </div>
            <div>
           
           

            <span style = {{marginTop:10}} >Identifiant magasin</span>
                <Input autoComplete  id="username" name="username" type="username" onChange={(event) => this.setState({IdentifiantMagasin: event.target.value})}   style = {{marginTop:2, marginBottom:10}} placeholder="Entrer l'identifiant magasin" />

                <span>Mot de passe</span>
                <Input autoComplete type="password" id="password" name="password"  onChange={(event) => this.setState({MotDePasse: event.target.value})}   style = {{marginTop:2}} placeholder="Entrer le mot de passe" />
                </div>

                <Button type="submit" onClick={this.onClickLogin}  style={{marginTop : 18, width : '100%', backgroundColor: '#0C4457', color: 'white', fontWeight : 900}}>Connexion</Button>
                  


          
                 
          
           
          </div>

        </div>

      )

    };
}


export default Login;
